import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenu, MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Visibility } from 'src/app/models/session';
import { IconTypes } from '../pencil-icon/pencil-icon.component';
import { PencilMenuItemComponent } from '../pencil-menu-item/pencil-menu-item.component';
export interface MenuItem {
  title: string;
  value: Visibility;
  description: string;
  imageSrc: string;
  selectedImageSrc: string;
}

@Component({
  selector: 'app-visibility-menu',
  templateUrl: './visibility-menu.component.html',
  styleUrls: ['./visibility-menu.component.scss'],
  standalone: true,
  imports: [CommonModule, MatMenuModule, MatIconModule, TranslateModule, PencilMenuItemComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VisibilityMenuComponent {
  @ViewChild(MatMenu) menu!: MatMenu;

  @Input() selectedValue!: string;

  @Input() dataName!: string;

  @Output() valueChanged = new EventEmitter<string>();

  Visibility = Visibility;
  IconTypes = IconTypes;
  constructor(private translate: TranslateService) {}
  visibilityMenuItems: MenuItem[] = [
    {
      title: this.translate.instant('PRIVATE'),
      value: Visibility.PRIVATE,
      description: this.translate.instant('Users must be invited to join this Space'),
      imageSrc: '/assets/svg-icons/person-with-lock-gray.svg',
      selectedImageSrc: '/assets/svg-icons/person-with-lock-blue.svg',
    },
    {
      title: this.translate.instant('PUBLIC'),
      value: Visibility.PUBLIC,
      description: this.translate.instant('Anyone with this link can access this Space'),
      imageSrc: '/assets/svg-icons/public-gray.svg',
      selectedImageSrc: '/assets/svg-icons/public-blue.svg',
    },
  ];

  changeValue(value: string): void {
    if (this.selectedValue !== value) {
      this.valueChanged.emit(value);
    }
  }
}
